import { get } from 'lodash';
import React, { FC } from 'react';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS } from 'src/lib/constants/componentsPath';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, ART_DES_ANTRAGS, FORM_FIELDS_TYPES } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import { concat } from 'lodash';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
import { NonRequired } from 'src/lib/validation/ValidationTypes';
import { mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
import AnlagenPruefAssistenzGlobal from './AnlagenPruefAssistenzGlobal';
const P = AntragSchema.attributes;

const SonstigeAnlagenGlobal: FC<{ showPruefAssistenz?: boolean; hasComment?: boolean }> = ({ showPruefAssistenz, hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const foerderprogramm = get(application, P.Foerderprogramm.path, {});
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Formantrag
		: FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Antrag;
	return (
		<>
			<ApplicationHeading
				title={get(foerderprogramm, paths.SontigeAnlageUnterTitel, 'Sonstige Anlagen')}
				description={get(foerderprogramm, paths.SontigeAnlageBeschreibung, '')}
			/>

			{showPruefAssistenz && (
				<>
					<AnlagenPruefAssistenzGlobal showHeading={false} />
				</>
			)}

			<CreateForm
				formStruc={formStrucSonstigeAnlagen()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default SonstigeAnlagenGlobal;

const formStrucSonstigeAnlagen = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Anlagen_Sonstige_Anlagen,
					type: FORM_FIELDS_TYPES.editableTable,
					fieldProps: { Bezeichnung_Des_Dokuments: { width: '15rem' } },
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStrucSonstigeAnlagen = (application: any, i: number): FormStrucItem[] => {
	const hatAnlage = get(application, addIndexToPath(P.Anlagen_Sonstige_Anlagen.schema.attributes.Datei.path, i, P.Anlagen_Sonstige_Anlagen.path));
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Anlagen_Sonstige_Anlagen.schema.attributes.Bemerkungen_Zum_Dokument,
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...P.Anlagen_Sonstige_Anlagen.schema.attributes.Bezeichnung_Des_Dokuments,
					validation: getTextFieldValidationByDatei(hatAnlage),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucSonstigeAnlagenGlobal = (application: any) => {
	const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');
	switch (antragsFormular) {
		case ANTRAGS_FORMULAREN.Loewe:
			const anlagenLength = get(application, P.Anlagen_Sonstige_Anlagen.path, []).length;
			let result: FormStrucItem[] = [];
			for (let i = 0; i < anlagenLength; i++) {
				const customFormStrucWithIndex = mapindexbyPath(customFormStrucSonstigeAnlagen(application, i), i, P.Anlagen_Sonstige_Anlagen);
				result = concat(result, customFormStrucWithIndex);
			}
			return result;
		default:
			return [];
	}
};
